import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalConfig, IconConfig, SpecialConfig, UpdateGlobalConfigRequestModel ,
  DefaultFees,
  UpdateDefaultFeesRequest,
  PortalConfig,
  UpdatePortalConfigRequest,
  TelegramAlerts,
  TelegramStatus,
  UpdateTelegramAlertsRequest,
} from './setting.type';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  private apiUrl = environment.apiBaseURL + '/settings';
  private telegramUrl = environment.apiBaseURL + '/telegram';

  constructor(
    private http: HttpClient,
  ) { }

  getConfig(): Observable<GlobalConfig> {
    return this.http.get<GlobalConfig>(`${this.apiUrl}`);
  }

  getIconConfig(): Observable<IconConfig> {
    return this.http.get<IconConfig>(`${this.apiUrl}/icon`);
  }

  getSpecialConfig(): Observable<SpecialConfig> {
    return this.http.get<SpecialConfig>(`${this.apiUrl}/special`);
  }

  updateIconConfig(config: Partial<IconConfig>): Observable<any> {
    return this.http.put(`${this.apiUrl}/icon`, config);
  }

  updateSpecialConfig(config: Partial<SpecialConfig>): Observable<any> {
    return this.http.put(`${this.apiUrl}/special`, config);
  }

  updateGlobalConfig(config: UpdateGlobalConfigRequestModel): Observable<any> {
    return this.http.put(`${this.apiUrl}/global`, config)
  }

  resetConfig(): Observable<any> {
    return this.http.post(`${this.apiUrl}/reset`, {});
  }

  // ── Supplier portal & default fees ──
  // These endpoints use the {result: ...} envelope; the older setting endpoints
  // above predate it and return bare objects.

  getTelegramAlerts(): Observable<TelegramAlerts> {
    return this.http
      .get<{ result: TelegramAlerts }>(`${this.apiUrl}/telegram-alerts`)
      .pipe(map(r => r.result));
  }

  updateTelegramAlerts(request: UpdateTelegramAlertsRequest): Observable<TelegramAlerts> {
    return this.http
      .put<{ result: TelegramAlerts }>(`${this.apiUrl}/telegram-alerts`, request)
      .pipe(map(r => r.result));
  }

  getTelegramStatus(): Observable<TelegramStatus> {
    return this.http
      .get<{ result: TelegramStatus }>(`${this.telegramUrl}/status`)
      .pipe(map(r => r.result));
  }

  sendTelegramTest(): Observable<void> {
    return this.http.post(`${this.telegramUrl}/test`, {}).pipe(map(() => undefined));
  }

  getDefaultFees(): Observable<DefaultFees> {
    return this.http
      .get<{ result: DefaultFees }>(`${this.apiUrl}/default-fees`)
      .pipe(map(r => r.result));
  }

  updateDefaultFees(request: UpdateDefaultFeesRequest): Observable<DefaultFees> {
    return this.http
      .put<{ result: DefaultFees }>(`${this.apiUrl}/default-fees`, request)
      .pipe(map(r => r.result));
  }

  getPortalConfig(): Observable<PortalConfig> {
    return this.http
      .get<{ result: PortalConfig }>(`${this.apiUrl}/portal`)
      .pipe(map(r => r.result));
  }

  updatePortalConfig(request: UpdatePortalConfigRequest): Observable<PortalConfig> {
    return this.http
      .put<{ result: PortalConfig }>(`${this.apiUrl}/portal`, request)
      .pipe(map(r => r.result));
  }
}
